import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "w-full p-2 bg-gray-700 rounded h-[400px] overflow-y-scroll" }
const _hoisted_2 = {
  key: 0,
  class: "hover:scale-[1.01] cursor-pointer p-2 rounded flex items-center justify-center text-gray-400"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "No items", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["onClick"]

interface Props {
  todoLists: string[]
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TodoListComponent',
  props: {
    todoLists: {}
  },
  emits: ["handleFilter"],
  setup(__props: any, { emit: emits }) {

const props = __props;





function handleClickCancel(index: number) {
  emits('handleFilter', (index as number))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.todoLists.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.todoLists, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "hover:scale-[1.01] cursor-pointer bg-gray-800 p-2 rounded px-4 m-2 mx-2 flex items-center justify-between shadow-lg"
      }, [
        _createElementVNode("span", null, _toDisplayString(item), 1),
        _createElementVNode("button", {
          class: "bg-gray-700 w-[25px] rounded-full flex item-center justify-center hover:bg-gray-600 transition duration-20 delay-10 hover:delay-0",
          onClick: ($event: any) => (handleClickCancel(index))
        }, "x", 8, _hoisted_5)
      ]))
    }), 128))
  ]))
}
}

})